import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
import { AddBrand } from "../../../../redux/reducer/brandReducer";
import ApiBase from "../../../../redux/constent";

const AddBrandForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { areas } = useSelector((state) => state.areas);

  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [selectedSuperCategoryId, setSelectedSuperCategoryId] = useState("");
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [selectedSuperCategories, setSelectedSuperCategories] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [desc, setDesc] = useState("");
  const [link, setLink] = useState("");
  const [image, setImage] = useState(null);

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (!selectedCategoryId) {
        setSelectedSubCategories([]);
        return;
      }

      try {
        const response = await fetch(
          `${ApiBase}/category/${selectedCategoryId}`
        );
        const data = await response.json();
        setSelectedSubCategories(data.subCategories || []);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        setSelectedSubCategories([]);
      }
    };

    fetchSubCategories();
  }, [selectedCategoryId]);

  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  useEffect(() => {
    const selectedArea = areas?.find((area) => area._id === selectedAreaId);
    if (selectedArea) {
      setSelectedSuperCategories(selectedArea.category || []);
    } else {
      setSelectedSuperCategories([]);
    }
    // console.log(selectedArea)
  }, [selectedAreaId, areas]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      if (!selectedSuperCategoryId) {
        setSubCategories([]);
        return;
      }

      const selectedSuperCategory = selectedSuperCategories.find(
        (cat) => cat._id === selectedSuperCategoryId
      );
      if (!selectedSuperCategory || !selectedSuperCategory.subCategory) {
        setSubCategories([]);
        return;
      }
      try {
        const categoryData = await Promise.all(
          selectedSuperCategory.subCategory.map(async (id) => {
            const response = await fetch(`${ApiBase}/subCategory/${id}`);
            const data = await response.json();
            // console.log(selectedSuperCategory)
            return data;
          })
        );
        setSubCategories(categoryData);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        setSubCategories([]);
      }
    };

    fetchSubCategories();
  }, [selectedSuperCategoryId, selectedSuperCategories]);

  // console.log("Area" + selectedAreaId)
  // console.log("category" + selectedSuperCategoryId)
  // console.log("subcategory" + selectedSubCategoryId)
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 bg-opacity-30bg-black">
      <div className="bg-white p-6 rounded-xl w-[90%] max-w-lg shadow-xl space-y-4">
        <h2 className="text-xl font-bold text-black">Add New Brand</h2>

        {/* Area Dropdown */}
        <select
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          onChange={(e) => setSelectedAreaId(e.target.value)}
          required
        >
          <option disabled selected value="" className="text-black">
            Choose Area
          </option>
          {areas?.map((area) => (
            <option className="text-black" key={area._id} value={area._id}>
              {area.name?.en}
            </option>
          ))}
        </select>

        {/* Category Dropdown based on selected Area */}
        <select
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          onChange={(e) => setSelectedSuperCategoryId(e.target.value)}
          required
        >
          <option disabled selected value="" className="text-black">
            Choose Category
          </option>
          {selectedSuperCategories?.map((cat) => (
            <option key={cat._id} value={cat._id} className="text-black">
              {cat.title?.en}
            </option>
          ))}
        </select>

        {/* SubCategory Dropdown (later to be dynamic) */}
        <select
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          onChange={(e) => setSelectedSubCategoryId(e.target.value)}
          required
        >
          <option disabled selected value="" className="text-black">
            Choose Sub Category
          </option>
          {subCategories?.map((subCat) => (
            <option
              key={subCat.data?._id}
              value={subCat.data?._id}
              className="text-black"
            >
              {subCat.data?.name?.en}
            </option>
          ))}
        </select>

        <hr />

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="Name EN"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={nameEn}
            onChange={(e) => setNameEn(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Name AR"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={nameAr}
            onChange={(e) => setNameAr(e.target.value)}
            required
          />
        </div>

        <div className="flex gap-2">
          <input
            type="file"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            onChange={(e) => setImage(e.target.files[0])}
            required
          />
          <input
            type="text"
            placeholder="Link"
            className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            required
          />
        </div>

        <textarea
          placeholder="Description"
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-lg"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />

        <div className="flex justify-end gap-4">
          {isLoading ? null : (
            <button
              className="px-4 py-2 text-sm text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
              onClick={onClose}
            >
              Cancel
            </button>
          )}
          {isLoading ? (
            <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
          ) : (
            <button
              className="px-4 py-2 text-sm text-black duration-300 rounded-lg hover:text-white bg-custom-yellow hover:bg-yellow-600"
              onClick={() => {
                setIsLoading(true); 

                dispatch(
                  AddBrand({
                    data: {
                      selectedAreaId,
                      selectedSuperCategoryId,
                      selectedSubCategoryId,
                      nameEn,
                      nameAr,
                      desc,
                      link,
                      image,
                    },
                  })
                )
                  .unwrap()
                  .then(() => {
                    alert("The brand has been added successfully.");
                  })
                  .catch((error) => {
                    alert("Failed to add the brand: " + error);
                  })
                  .finally(() => {
                    setIsLoading(false);
                    onClose();
                  });
              }}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddBrandForm;
